// Unpublished Work © 2024-2025 Deere & Company.

import React, { FC } from "react";
import { Alert } from "@deere/isg.component-library";
import { User } from "./types";

type NoAccessProps = {
  user: User;
};

export const NoAccess: FC<NoAccessProps> = ({ user }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "100vh",
        padding: "4rem 1rem",
        background: "#f5f5f5",
      }}
    >
      <div style={{ maxWidth: 640, width: "100%" }}>
        <Alert severity="warning" title="Access not configured">
          <p style={{ marginTop: 0 }}>
            Hi {user.name || user.userId}, your account is signed in but does not
            have permission to use Orchestrator yet.
          </p>
          <p>
            Please contact your system administrator and ask them to grant your
            account access. Reference your user ID when you reach out:
          </p>
          <p>
            <strong>{user.userId}</strong>
          </p>
          <p style={{ marginBottom: 0 }}>
            Once an administrator adds you, reload this page to continue.
          </p>
        </Alert>
        <div style={{ marginTop: 24, textAlign: "center" }}>
          <a
            href="/API/auth/logout"
            style={{
              display: "inline-block",
              padding: "8px 16px",
              borderRadius: 4,
              border: "1px solid #555",
              textDecoration: "none",
              color: "#222",
              background: "white",
            }}
          >
            Sign out
          </a>
        </div>
      </div>
    </div>
  );
};
